import { css } from "@emotion/core";
import { color, fontTypes } from "../../constants/commons";

export const modalContentStyles = (mobileView: boolean) => css`
  .modal-pop-up-content {
    text-align: left;
  }
  .name-container {
    display: flex;
    margin-bottom: 0.63em;
    ${mobileView
      ? `flex-direction: column;`
      : `align-items: baseline;
    justify-content: left;`}
    span {
      text-transform: capitalize;
      margin-left: 0.75em;
    }
  }
  .text-container {
    color: ${color.lightishGray};
    font-family: ${fontTypes.meduim};
  }
`;

export const partnersSpeakStyles = (
  mobileView: boolean,
  backgroundColor?: string
) => css`
  text-align: left;
  .card-container {
    ${backgroundColor && `background-color: ${backgroundColor};`}
    display: flex;
    padding: 1em;
    min-width: 18em;
    height: 100%;
  }
  .name-container {
    display: flex;
    margin-bottom: 0.63em;
    span {
      text-transform: capitalize;
    }
  }
  ${!mobileView &&
  `padding-bottom: 1.88em;
    min-width: 23em;
    button:focus {
      outline: none;
    }
    .card-container {
      flex-direction: row;
      align-items: center;
      min-width: initial;
      max-width: 98%;
      video, img {
        max-width: 24em;
        margin-right: 2em;
        border-radius: 0.75em;
      }
      /* Medium devices (tablets, 768px and up) */
      @media (min-width: 768px) and (max-width: 991.98px) {
        .name-container {
          h5 {
            font-size: 1em;
          }
        }
        video, img {
          max-width: 15em;
        }
        h3{
          font-size: 1.25em;
        }
        .video-button {
          font-size: 0.75em;
          img {
            height: 1em;
          }
        }
      }
    }
    .carousel-data-container{
      height: 100%;
    }
    .video-container{
      position: relative;
      .author-img{
        height: 16em;
      }
      button{
        position: absolute;
        border-radius: 2em;
        padding: 0.75em 1.25em;
        left: 1.06em;
        bottom: 1.67em;
        background: white;
        cursor: pointer;
        color: ${color.red};
        border: none;
        font-family: ${fontTypes.bold};
        display: flex;
        align-items: flex-start;
        img{
          margin: 0 0.5em 0 0;
        }
      }
    }
    .name-container {
      flex-direction: row;
      align-items: baseline;
      span {
        margin-left: 0.75em;
      }
    }
    `}
  ${mobileView &&
  `.card-container {
      flex-direction: column;
      align-items: center;
      video, img {
        border-radius: 0.75em;
        width: 100%;
        margin-bottom: 0.75em;
      }
      .name-container {
        flex-direction: column;
        h5 {
          margin: 0;
          font-size: 1em;
        }
      }
      h3{
        font-size: 1.25em;
      }
    }
    .video-container{
      position: relative;
      .author-img{
        height: 9em;
        width: auto;
      }
      button{
        position: absolute;
        border-radius: 50%;
        padding: 1em 1em 1em 1.3em;
        left: 37%;
        bottom: 45%;
        background: white;
        cursor: pointer;
        color: ${color.red};
        border: none;
        img {
          margin: 0;
        }
      }
    }
    .responsive-widget-item {
      margin-right:0;
    }
    .carousel-data-container{
      margin-right:1em;
    }
    `}
`;
